import { render, staticRenderFns } from "./FeedbackDialog.vue?vue&type=template&id=76aaeb8e&scoped=true"
import script from "./FeedbackDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./FeedbackDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FeedbackDialog.vue?vue&type=style&index=0&id=76aaeb8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76aaeb8e",
  null
  
)

export default component.exports